module.exports = __webpack_public_path__ + "img/4.1122c69.1122c694.png";